export const isNonEmptyArray = (el: any) => {
  return Array.isArray(el) && el.length > 0
}
